import { Box, useTheme } from "@mui/material"
import { Head } from "components/Head"
import { useTranslation } from "react-i18next"
import { useService } from "hooks/service/useService"
import { EmptyData } from "components/EmptyData"
import { useMemo } from "react"
import { getIcon } from "utils/icon"
import { ServiceIcon } from "components/icons"
import { ServiceCard } from "extensions/iconsiam/components/domains/service/card"
import { PageLayout } from "extensions/iconsiam/layouts/PageLayout"
import { Header } from "extensions/iconsiam/components/Header"
import { VenueFilterBar } from "extensions/iconsiam/components/VenueFilterBar"
import { HeaderSearchButton } from "extensions/iconsiam/components/Header/HeaderSearchButton"
import { Link } from "react-router-dom"

export const ServicesPage = ({ Layout = PageLayout }) => {
  const { t } = useTranslation()
  const { services, hasData, changeVenueFilter, venueFilter } = useService()
  const theme = useTheme()
  const { root, gridContainer, gridItem, emptyDataContainer } =
    theme.components?.[`ServicesPage`]?.styleOverrides || {}

  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.service) || <ServiceIcon />,
    [theme]
  )

  return (
    <>
      <Head title={t("Services")} />
      <Layout
        header={
          <Header
            filterBar={
              <VenueFilterBar
                onClickVenue={changeVenueFilter}
                value={venueFilter}
              />
            }
            searchButton={<HeaderSearchButton />}
          />
        }
      >
        <Box sx={root}>
          {hasData ? (
            <Box sx={gridContainer}>
              {services.map((service) => (
                <Link
                  to={
                    service.locations.length > 0
                      ? `/services/${service.id}`
                      : ""
                  }
                  key={`service-item-${service.id}`}
                >
                  <ServiceCard sx={gridItem} data={service} />
                </Link>
              ))}
            </Box>
          ) : (
            <Box sx={emptyDataContainer}>
              <EmptyData
                icon={emptyIcon}
                primary={t("No Services")}
                secondary={t("Stay tuned for the update")}
              />
            </Box>
          )}
        </Box>
      </Layout>
    </>
  )
}
